<template>
  <li class="px-3 py-2 rounded-lg m-1">
    <ColorPicker v-model="localValue" class="" @colorChanged="colorChanged" :namespace="namespace" :alwaysOpen="true"/>
  </li>
</template>
<script>

// import { midnight, isPast, daysFromDate } from '@/helpers/date'

export default {
  components: {
  },
  props: ['icon', 'title', 'disabled', 'value', 'namespace'],
  data () {
    return {
      localValue: null,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.localValue = value
      }
    },
    localValue: {
      immediate: false,
      handler (localValue) {
        // this.$emit('colorChanged', localValue)
      }
    }
  },
  methods: {
    colorChanged (color) {
      this.$emit('colorChanged', color)
    }
  },
  computed: {
  },
}
</script>

<style scoped>
</style>
